import { createMenuScreen } from './presentation/screens/menu';
import { createSettingsScreen } from './presentation/screens/settings';
import { createGameScreen } from './presentation/screens/game';
import { createGameOverScreen } from './presentation/screens/gameOver';
import { createRouter, type ScreenRegistry } from './router';

const rootEl = document.getElementById('app');
if (!rootEl) {
  throw new Error('Missing #app root element');
}

const registry: ScreenRegistry = {
  menu: createMenuScreen,
  settings: createSettingsScreen,
  game: createGameScreen,
  gameOver: createGameOverScreen,
};

createRouter(rootEl, registry).start('menu');
